import React from 'react';
/*import {ButtonReject} from '../../../../component/Button.js'*/

export default class RequestMaintenanceRow extends React.PureComponent {
  constructor(props) {
    super(props);

    this.createWork = this.createWork.bind(this)
    this.reject = this.reject.bind(this)
  }

  createWork() {
    const {RowData} = this.props;
    this.props.onCreateWork(RowData.Alias, RowData.Asset.Name, RowData.Description)
  }

  reject(e) {
    const {RowData} = this.props;
    this.props.onRejectWork(RowData.Alias, RowData.Asset.Alias, RowData.Service.Alias, RowData.Description)
  }

  render() {
    const {RowData} = this.props;
    let butonCreateWork, buttonRejectWork;

    if(RowData.Work !== null) {
      buttonRejectWork = null;
      butonCreateWork = <button key={1} className="btn btn-sm btn-default" disabled>Work Created</button>;

    }else if (RowData.Rejected){
      butonCreateWork = null;
      buttonRejectWork = <button key={2} className="btn btn-sm btn-default" disabled>Request Rejected</button>;
      
    } else {
      butonCreateWork = <button key={1} className="btn btn-sm btn-primary" onClick={this.createWork}>Create Work</button>;
      buttonRejectWork = <button key={2} className="btn btn-sm btn-danger" onClick={this.reject}>Reject</button>;
    }

    return (
      <tr>
        <td>{RowData.Asset.Name}</td>
        <td>{RowData.Service.Name}</td>
        <td>{RowData.Owner.FirstName}&nbsp;{RowData.Owner.LastName}</td>
        <td>{RowData.Description}</td>
        <td className="text-center">{[butonCreateWork,' ', buttonRejectWork]}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/request/helper/component/RequestMaintenance/RequestMaintenanceRow.js